import Login from '@/screens/sessions/Login'
import Register from '@/screens/sessions/Register'
import ThankYou from '@/screens/sessions/ThankYou'
import Logout from '@/screens/sessions/Logout'
import RecoveryPassword from '@/screens/sessions/RecoveryPassword'
import ResetPassword from '@/screens/sessions/ResetPassword'
import VerifyAccount from '@/screens/sessions/VerifyAccount'
import AcceptInvitation from '@/screens/sessions/AcceptInvitation'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/thankyou',
    name: 'ThankYou',
    component: ThankYou
  },
  {
    path: '/recovery-password',
    name: 'RecoveryPassword',
    component: RecoveryPassword
  },
  {
    path: '/set-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/verify/:id',
    name: 'VerifyAccount',
    component: VerifyAccount
  },
  {
    path: '/invitations/:id',
    name: 'AcceptInvitation',
    component: AcceptInvitation
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  }
]

export default routes
